import React, { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useCurrencyContext } from '../../../../_providers/Currency';

function Currencies(props) {

    const currencies = useCurrencyContext();

    const [tabs, setTabs] = useState({
        tab: 1,
        ripple: true
    });

    const handleTabs = (e, newValue) => {
        props.callbackValue(newValue);
    };

    return (
        <Tabs
            value={props.tab}
            onChange={handleTabs}
            variant="scrollable"
            scrollButtons="auto"
            indicatorColor="primary"
            textColor="primary"
            aria-label="scrollable force tabs example"
        >

            {currencies.map(currency =>
                <Tab key={currency.id} value={currency.id} label={currency.name} disableRipple={tabs.ripple} />
            )}
        </Tabs>
    )
}

export default Currencies;